import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import NavigationSidebar from "../components/Navigationsidebar/NavigationSidebar";
import FilterSidebar from "../components/FilterSidebar/FilterSidebar";
import Scatterplot01 from "../components/Dashboardviz/D12/D12Viz01/index";
import { useFilter } from "../FilterContext";
import { FILTER_CONFIG } from "../config/filterconfig";
import jsonData from "../current-survey-numeric.json";
import "./D12_Engagement_Areas_by_Impact.css";

const Dashboard = () => {
  const { filterCriteria, setFilterCriteria } = useFilter();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState({});

  // Dynamically generate filter options based on FILTER_CONFIG
  useEffect(() => {
    const generateFilterOptions = () => {
      const options = {};
      FILTER_CONFIG.forEach(({ fieldName, jsonKey, sortOrder }) => {
        let uniqueValues = [...new Set(jsonData.map((item) => item[jsonKey]))];
        uniqueValues = uniqueValues.filter((value) => value !== null);

        // Apply sorting based on sortOrder if available
        if (sortOrder) {
          uniqueValues = uniqueValues.sort(
            (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b)
          );
        } else {
          uniqueValues = uniqueValues.sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: "base" })
          );
        }

        options[fieldName] = uniqueValues;
      });

      return options;
    };

    setFilterOptions(generateFilterOptions());
  }, []);

  const toggleSidebar = useCallback(() => setIsSidebarOpen((prev) => !prev), []);
  
  const toggleFilterSidebar = useCallback(() => setIsFilterSidebarOpen((prev) => !prev), []);

  // Update refresh function to use window.location.reload()
  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <div className="D12_Engagement_Areas_by_Impact-dashboard-container">
      <Header
        title="Engagement Summary"
        toggleSidebar={toggleSidebar}
        refreshPage={refreshPage}
        toggleFilterSidebar={toggleFilterSidebar}
      />
      <NavigationSidebar isOpen={isSidebarOpen} />
      <FilterSidebar
        isOpen={isFilterSidebarOpen}
        filterOptions={filterOptions}
        setFilterCriteria={setFilterCriteria}
      />
      <div className="D12_Engagement_Areas_by_Impact-main-content">
        <div className="D12_Engagement_Areas_by_Impact-content-wrapper">
          <div className="D12_Engagement_Areas_by_Impact-charts-wrapper">
            <div className="D12_Engagement_Areas_by_Impact-charts-container">
              <div className="D12_Engagement_Areas_by_Impact-chart">
                <h2 className="D12_Engagement_Areas_by_Impact-chart-title">
                  Engagement Areas by Impact
                </h2>
                <Scatterplot01 filterCriteria={filterCriteria} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;